import ImmutableUtils from "../../utils/ImmutableUtils";
import PropertyMaps from "../../constants/PropertyMaps";
import AppConstants from "../../constants/AppConstants";
import { List } from "immutable";
import { SYNCED_PROPS } from "../../constants/DesignConstants.mjs";

const deleteAction = { action: AppConstants.UPDATE_ACTION_DELETE };

const setColumnDefaults = (payloads, overUserNoColumn, currentOverflow) => {
  let changes = [
    { ...payloads.columns, ...deleteAction },
    { ...payloads.columnGap, ...deleteAction },
  ];
  if (overUserNoColumn) {
    if (overUserNoColumn !== AppConstants.TEXT_OVERFLOW_CROP) {
      changes.push({ ...payloads.overflow, value: overUserNoColumn });
    }
    changes.push({ ...payloads.overUserNoColumn, ...deleteAction });
  } else if (currentOverflow) {
    changes.push({ ...payloads.overflow, value: AppConstants.TEXT_OVERFLOW_DISPLAY });
  }
  return changes;
};

const setMultiColumn = (payloads, newValue, currentOverflow, currentGap, element) => {
  let changes = [{ ...payloads.columns, value: newValue }];
  if (!currentGap) {
    changes.push({ ...payloads.columnGap, value: 30 });
  }
  if (currentOverflow !== AppConstants.TEXT_OVERFLOW_CROP) {
    const sync = List(element?.get(SYNCED_PROPS) || []);
    const index = sync.indexOf("over");
    if (index > -1) {
      const newSync = sync.delete(index);
      changes.push(
        { name: "mobile.over", value: element?.getIn(["desktop", "over"], currentOverflow) },
        { name: SYNCED_PROPS, value: newSync.size 
          ? newSync : null, action: newSync.size 
          ? AppConstants.UPDATE_ACTION_SET : false }
      );
    }
    changes.push({ ...payloads.overflow, value: AppConstants.TEXT_OVERFLOW_CROP });
  }
  if (currentOverflow && !payloads.columns.origValue) {
    changes.push({ ...payloads.overUserNoColumn, value: currentOverflow });
  }
  return changes;
};

const buildColumnUpdates = (element, newValue) => {
  const elemProps = element.get("desktop");
  const textProps = elemProps.filter(ImmutableUtils.keyIn(PropertyMaps.TEXT_STYLE_PROPS));
  const columnCnt = textProps.get("columnCnt");
  const overUserNoColumn = elemProps.get("overUserNoColumn", "");
  const currentGap = textProps.get("columnGap");
  const currentOverflow = elemProps.get("over", "");

  const payloads = {
    columns: { name: "desktop.columnCnt", origValue: columnCnt },
    columnGap: { name: "desktop.columnGap", origValue: currentGap },
    overflow: { name: "desktop.over", origValue: currentOverflow },
    overUserNoColumn: { name: "desktop.overUserNoColumn", value: currentOverflow },
  };

  if (newValue) {
    if (newValue !== 1) {
      return setMultiColumn(payloads, newValue, currentOverflow, currentGap, element);
    } else {
      return setColumnDefaults(payloads, overUserNoColumn, currentOverflow);
    }
  } else if (columnCnt) {
    return setColumnDefaults(payloads, overUserNoColumn, currentOverflow);
  } else {
    return [];
  }
};

export default {
  buildColumnUpdates,
  setMultiColumn,
  setColumnDefaults,
};
